import { ZFList } from './zf-list/zf-list';
import { NgModule } from '@angular/core';
import { ZFText } from './zf-text';
import { CommonModule } from '@angular/common';
import { ZFButton } from './zf-button/zf.button';
import { ZFButtonGroup } from './zf-button-group';
import { ZFTabs } from './zf-tabs/zf-tabs';
import { IonicModule } from '@ionic/angular';
import { ZFGroupSeparator } from './zf-group-separator';
import { ZfFloatingLabel } from './zf-floating-label/zf-floating-label';
import { ZFSelectorList } from './zf-selector-list/zf-selector-list';
import { FormsModule } from '@angular/forms';
import { UiModule } from '@monorepo/ui';

@NgModule({
  declarations: [ZFSelectorList, ZFList, ZfFloatingLabel, ZFGroupSeparator, ZFTabs, ZFButtonGroup, ZFButton, ZFText],
  exports: [ZFSelectorList, ZFList, ZfFloatingLabel, ZFGroupSeparator, ZFTabs, ZFButtonGroup, ZFButton, ZFText],
  imports: [CommonModule, IonicModule, FormsModule, UiModule],
  providers: [],
})
export class UICompModule {}
